// Reader for the cross-subdomain "is this browser signed in?" flag.
//
// The studio host (studio.retira.app) holds the real Supabase session in
// origin-scoped localStorage, which the demo host (retira.app) cannot read. So
// studio writes a tiny boolean cookie on the shared parent domain (see
// authPresenceWriter.js) and the demo reads it here to notice a logged-in user.
//
// This file intentionally has ZERO imports. It is bundled into the public/demo
// surface, which must never pull in Supabase or other studio-only code. Keeping
// it import-free also keeps it out of any chunk shared with the studio graph,
// which is what would otherwise drag Supabase into the demo bundle.
//
// AUTH_PRESENCE_COOKIE is duplicated in authPresenceWriter.js on purpose (so the
// two surfaces share no module); the two literals must stay in sync.
const AUTH_PRESENCE_COOKIE = 'retira_authed'

// Reads the flag. Safe to call from the demo surface – never touches Supabase.
export function hasAuthPresence() {
  if (typeof document === 'undefined') return false

  return document.cookie.split('; ').some((entry) => {
    const separatorIndex = entry.indexOf('=')
    const name = separatorIndex === -1 ? entry : entry.slice(0, separatorIndex)
    const value = separatorIndex === -1 ? '' : entry.slice(separatorIndex + 1)
    return name === AUTH_PRESENCE_COOKIE && value === '1'
  })
}
